<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="epig"> </p>
<p class="FEP"><span class="ePub-I">But thou, O God, shalt bring them down into the pit of destruction: bloody and deceitful men shall not live out half their days</span></p>
<p class="CEPCR"><span class="ePub-SC">—PSALM 55</span> </p>
<p class="FEP"><span class="ePub-I">They were killing people at bus stops, walking in their house and killing them, walking in nightclubs and killing them. People were found in backs of trunks with their heads sawed off. People were found in suitcases, dissected. Guys were found floating in the river. There was a lot of hits in Boston and all different types of hits.…</span></p>
<p class="CEPCR"><span class="ePub-SC">—JOSEPH BARBOZA</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?387669e1